import { render, staticRenderFns } from "./LoadingCover.vue?vue&type=template&id=b86d1efe&"
import script from "./LoadingCover.vue?vue&type=script&lang=ts&"
export * from "./LoadingCover.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b86d1efe')) {
      api.createRecord('b86d1efe', component.options)
    } else {
      api.reload('b86d1efe', component.options)
    }
    module.hot.accept("./LoadingCover.vue?vue&type=template&id=b86d1efe&", function () {
      api.rerender('b86d1efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/LoadingCover.vue"
export default component.exports